<template>
  <div>
    <b-form @submit.prevent="save">
        <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <b-form-group
                  :label="$t('receiving_emails')"
                  label-for="emailsInput">
                <validation-provider
                  #default="{ errors }"
                  name="emailsInput">
                  <!--Tags input-->
                  <emails-input
                    ref="emailsInput"
                    :emailsInput="emailsInitialTag"
                    @emailsChanged="emailsChanged"
                    :sendButton="false"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </div>
          </div>
          <div class="flex justify-end mb-4">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="float-right mr-1"
              type="submit">
              Salvar
            </b-button>
            <b-button
                v-if="!hideBackButton"
                variant="outline-secondary"
                class="float-right"
                @click="goBack">
                <feather-icon
                  icon="CornerUpLeftIcon"
                  class="mr-50"/>
                <span class="align-middle">{{$t('back')}}</span>
            </b-button>
          </div>
      </b-form>
      <!-- -->
    <b-card-code
      :key="`${legalEntityId}-dd-form`"
      title="URL Formulário de Análise de Fornecedores"
      codeVisible="true"
      showCopy="true"
      codeEmbed="true"
      :shortUrl="shortUrl">
      <b-card-text>
        Use esta URL para que a instituição/empresa possa abrir o formulário de análise de fornecedores.
      </b-card-text>
      <template #code>
        {{ formUrl }}
      </template>
    </b-card-code>
    <div v-if="!hideBackButton" class="flex justify-end">
      <b-button
          variant="outline-secondary"
          class="float-right"
          @click="goBack">
          <feather-icon
            icon="CornerUpLeftIcon"
            class="mr-50"/>
          <span class="align-middle">{{$t('back')}}</span>
        </b-button>
    </div>
  </div>
</template>

<script>
import {
  BForm, BButton, BFormGroup, BInputGroup, BFormTextarea, BCardText, BFormInput
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import BCardCode from '@core/components/b-card-code'
import ComplexEditor from '@/components/ComplexEditor.vue'
import EmailsInput from '@/components/EmailsInput.vue'

import LegalEntityFormDueDiligenceService from '@/services/api/form/LegalEntityFormDueDiligenceService'


export default {
  components: {
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardCode,
    BCardText,
    BFormInput,
    // validations
    ValidationProvider,
    ValidationObserver,
    ComplexEditor,
    EmailsInput,
  },
  props: {
    legalEntityId: {
      type: Number,
      default: null
    },
    legalEntityRecord: {
      type: Object,
      default: null
    },
    hideBackButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      legalEntity: null,
      emails: [],
      emailsInitialTag: [],
      service: LegalEntityFormDueDiligenceService.build(this.$vs)
    }
  },
  watch: {
    legalEntityRecord: {
      immediate: true,
      handler(val) {
        if (val != null) {
          this.legalEntity = val
          if (this.legalEntityId) {
            this.getData(this.legalEntityId)
          }
        }
      }
    },
    //Não retirar, verificar a lógica da consulta da legalEntity
    '$store.state.legalEntity.legalEntity': {
      immediate: true,
      handler(legalEntity) {
        if (this.legalEntityRecord != null) {
          return
        }
        this.legalEntity = legalEntity
        if (this.legalEntity && this.legalEntityId) {
          this.getData(this.legalEntity.id)
        }
      }
    }
  },
  computed: {
    formUrl() {
      if (this.legalEntity && this.legalEntity.due_diligence_form_url) {
        return `${this.legalEntity.due_diligence_form_url}`
      }
      return ''
    },
    shortUrl(){
      if (this.legalEntity && this.legalEntity.due_diligence_short_url) {
        return `${this.legalEntity.due_diligence_short_url}`
      }
      return null
    }
  },
  methods: {
    goBack() {
      if (this.hideBackButton) {
        return
      }
      this.$store.commit('legalEntity/UPDATE_LEGAL_ENTITY', null)
      this.$router.push({name: 'people-legal-entities'})
    },
    save() {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      const params = {
        id: this.legalEntityId,
        legal_entity_id: this.legalEntityId,
        emails: this.emails
      }

      this.service.createOrUpdate(params).then(
        data => {
          this.notifySuccess(this.$vs)
        },
        error => {
          this.showErrors(this.$validator, error)
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    getData(id) {
      const promisses = []
      this.$vs.loading()
      promisses.push(
        this.service.read(id).then(
          data => {
            this.emailsInitialTag = _.get(data, 'data.emails')
            this.$vs.loading.close()
          },
          error => {
            this.$vs.loading.close()
          }
        ).finally(() => {
            this.$vs.loading.close()
          }
        )
      )//End promisses
      Promise.all(promisses).then(() => {
        this.$vs.loading.close()
        console.log('all load...')
      })
    },
    emailsChanged(emails) {
      this.emails = emails
    }
  },
  mounted() {
    if (this.legalEntityRecord != null) {
      return
    }
    if (this.legalEntityId && !this.legalEntity) {
      this.getData(this.legalEntityId)
    }
  },
  beforeDestroy() {
    this.destroyChilds(this)
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
